import {
  CampaignsFragment,
  Product,
  ProductUserReviews,
  ReviewType,
  UserReview,
  UserReviewSummary,
  Campaign,
  CampaignBanner,
  ProductPageQuery,
  User,
  Maybe,
  CampaignMediaColors,
  ProductProperties,
} from '../../types';

type PendingRequest = {
  type: 'create' | 'edit' | 'delete';
};

export type Review = {
  myReview?: UserReview;
  open: boolean;
  pendingRequest?: PendingRequest;
  reviewType?: ReviewType;
  userReviews?: ProductUserReviews & { summary: UserReviewSummary };
  belongsTo?: number;
};

export type RouteSection = 'main' | 'properties' | 'reviews' | 'statistics';

export type CurrentModal = string | undefined;

type CampaignFragment = ArrayElement<
  NonNullable<CampaignsFragment['campaigns']>
>;

export type CurrentCampaign = CampaignFragment & {
  name: string;
  path: string;
  media: {
    colors?: Maybe<CampaignMediaColors>;
  };
};

type Price = NonNullable<Product['prices']>;
export type PriceNode = ArrayElement<NonNullable<Price['nodes']>>;

export enum ProductPriceType {
  NORMAL = 'normal',
  NOT_IN_MINT_CONDITION = 'not_in_mint_condition',
  CONSUMER_WARNING = 'consumer_warnings_received',
  CALL_FOR_INFORMATION = 'call_for_information',
  UNAVAILABLE = 'not_available_for_purchase',
  USED_PRODUCT = 'used_product',
  CLASSIFIED = 'classified',
  DOWNLOAD = 'download',
  PHYSICAL_STORE = 'price_in_physical_store',
  PICKUP_ONLY = 'pickup_only',
  PRICE_MIGHT_BE_WRONG = 'price_might_be_wrong',
  INTERNATIONAL = 'international',
}

export type ProductPageData = ProductPageQuery & {
  product: Product & Maybe<{ coreProperties: ProductProperties }>;
};

type ProductPageOwnProps = {
  activeCampaign: Campaign;
  data: ProductPageData;
  routeSection: RouteSection;
};

type ProductPageStateProps = {
  campaignBanners: {
    active: (CampaignBanner & {
      campaign: Pick<Campaign, 'media'>;
    })[];
  };
  currentModal: CurrentModal;
  me: User;
  review: Review;
};

type ProductPageDispatchProps = {
  hideModal: () => void;
};

export type ProductPageProps = ProductPageOwnProps &
  ProductPageStateProps &
  ProductPageDispatchProps;
